import AlertIcon from "@uui/AlertCircle";

import { Box, Typography } from "@mui/material";

import ConfirmationModal, {
  ConfirmationModalProps,
} from "@rui/ConfirmationModal";
import IconBackground from "@rui/IconBackground";
import { Column } from "@rui/Stack";

import { IncompleteDetailsWithFix } from "./incompleteReasonDetails";

interface DetailsDialogProps
  extends Omit<ConfirmationModalProps, "children" | "onConfirm"> {
  open: boolean;
  details: IncompleteDetailsWithFix | null;
  onClickCta: (details: IncompleteDetailsWithFix) => void;
}

const DetailText = ({ label, value }: { label: string; value: string }) => (
  <Typography variant="bodyPrimaryReg">
    <Box component="span" sx={{ fontWeight: 500 }}>
      {label}:
    </Box>{" "}
    {value}
  </Typography>
);

const DetailsModal = ({
  details,
  onClickCta,
  ...props
}: DetailsDialogProps) => {
  if (!details) {
    return null;
  }

  const handleIgnore = () => props?.onClose();

  const handleClickCta = () => {
    onClickCta(details);
  };

  return (
    <ConfirmationModal
      open={props.open}
      onClose={handleIgnore}
      onCancel={handleIgnore}
      onConfirm={handleClickCta}
      icon={
        <IconBackground height={24} sx={{ bgcolor: "shades.negative.50" }}>
          <AlertIcon sx={{ color: "error.main" }} />
        </IconBackground>
      }
      title="Restricted Data"
      confirmProps={{ label: "Enable Setting" }}
      cancelProps={{ label: "Ignore" }}
    >
      <Column spacing="4px">
        <DetailText label="Issue" value={details.message} />
        <DetailText label="Outcome" value={details.outcome} />
        <DetailText label="Fix" value={details.fix} />
      </Column>
    </ConfirmationModal>
  );
};

export default DetailsModal;
